export default "__VITE_ASSET__CkK0dmp5__"